// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2cBbM","gfeWrapper":"CalendarEvent_gfeWrapper__2Njx_"};